export default __webpack_public_path__ + "static/media/thumbnail_image_7.a78b014e.png";